import { Button, Typography } from '@mui/material';
import { ContractPageVersion } from '@vy/api-definition';
import { VyIcon } from '@vy/ui-design-system';
import { Optional } from '@vy/utils';
import { FC } from 'react';
import { ContractVersionsSelect } from '../../ContractPageHeader/contract-page-header-components/ContractVersionsSelect';

type ContractTabActionsProps = {
  isVersioned: boolean;
  versionIdFromUrl?: Optional<string>;
  setVersionIdInUrl: (versionId: Optional<string>) => void;
  versions: ContractPageVersion[];
  contractId: string;
  onAddPhase: () => void;
};

export const ContractTabActions: FC<ContractTabActionsProps> = ({
  isVersioned,
  versionIdFromUrl,
  setVersionIdInUrl,
  versions,
  contractId,
  onAddPhase,
}) => {
  return (
    <>
      {isVersioned && (
        <ContractVersionsSelect
          versionIdFromUrl={versionIdFromUrl}
          setVersionIdInUrl={setVersionIdInUrl}
          versions={versions}
          contractId={contractId}
        />
      )}
      <Button
        variant="text"
        sx={{ width: '130px' }}
        startIcon={<VyIcon icon="PlusMedium" transform="scale(0.8)" />}
        onClick={onAddPhase}
      >
        <Typography
          sx={{
            fontSize: "13px",
            fontWeight: 400
          }}>
          Add phase
        </Typography>
      </Button>
    </>
  );
};
